import {call, put, takeEvery} from "redux-saga/effects";
import {
    GET_TARIFF_REQUEST,
    GET_TARIFF_REQUEST_SUCCESS,
    GET_TARIFFS_REQUEST, GET_TARIFFS_REQUEST_SUCCESS, UPDATE_TARIFFS_REQUEST, UPDATE_TARIFFS_REQUEST_SUCCESS,
} from "./actionTypes";


import {notification} from 'antd';

const modalSuccess = type => {
    notification[type]({
        message: 'წარმატება',
        description: 'ოპერაცია წარმატებით შესრულდა',
    });
};

const modalError = type => {
    notification[type]({
        message: 'შეცდომა',
        description: 'მოხდა შეცდომა მიმართეთ IT განყოფილებას',
    });
};

function* getTariffsSaga({payload}) {
    try {
        const callBack = yield call(getTariffsSagaAsync)

        if (callBack){
           yield put({type: GET_TARIFFS_REQUEST_SUCCESS, callBack})
        }
    } catch (e) {
        console.error(e);
    }
}

const getTariffsSagaAsync = async () => {
    let jwt = localStorage.getItem("token")
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/tariffs/gets`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Authorization': `Bearer ${jwt}`,
        },
    })
    return await response.json()
}

function* getTariffSaga({payload}) {
    try {
        const callBack = yield call(getTariffSagaAsync, payload)

        if (callBack){
           yield put({type: GET_TARIFF_REQUEST_SUCCESS, callBack})
        }
    } catch (e) {
        console.error(e);
    }
}

const getTariffSagaAsync = async (item) => {
    let jwt = localStorage.getItem("token")
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/tariffs/get/${item.id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Authorization': `Bearer ${jwt}`,
        },
    })
    return await response.json()
}

function* updateTariffSaga({payload}) {
    try {
        const callBack = yield call(updateTariffSagaAsync, payload)
        if (callBack){
            yield put({type: UPDATE_TARIFFS_REQUEST_SUCCESS, payload})
        }
    } catch (e) {
        console.error(e);
    }
}

const updateTariffSagaAsync = async (item) => {
    let jwt = localStorage.getItem("token")
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/tariffs/update`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Authorization': `Bearer ${jwt}`,
        },
        body : JSON.stringify(item)
    })
    return await response.json()
}


function* informationSaga() {
    yield takeEvery(GET_TARIFFS_REQUEST, getTariffsSaga)
    yield takeEvery(GET_TARIFF_REQUEST, getTariffSaga)
    yield takeEvery(UPDATE_TARIFFS_REQUEST, updateTariffSaga)
}

export default informationSaga
